import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { APP_ROUTES } from '../../constants/app-routes';
import { getUserByCognitoId } from '../../core/users/action';

const ALLOWED_ROUTE_PREFIXES = ['/app/'];

function isSafeRoute(route) {
  if (!route) return false;
  return ALLOWED_ROUTE_PREFIXES.some((prefix) => route.startsWith(prefix));
}

function StripeValidationPage() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const route = params.get('route');
  const safeRoute = isSafeRoute(route) ? route : APP_ROUTES.DASHBOARD;

  dispatch(getUserByCognitoId(user.cognito_id));

  return <Navigate to={safeRoute} replace />;
}

export default StripeValidationPage;
